import React, { useState } from 'react'
import { CustomTab } from '../../../components';
import styles from "./styles.module.css"
import { useSelector } from 'react-redux';
import BookStudyMaterial from './BooksMaterial/BookStudyMaterial';
import ListAssessment from "./assessment/ListAssessment"
import ListRemedial from './remedial/ListRemedial';
import { useLocation } from 'react-router-dom';
function BookAssessment() {
  const { language, translations } = useSelector((state) => state.language);
  const location = useLocation();
  const initialTab = Number(location.state?.activeTab) || 0;
  const [activeTab, setActiveTab] = useState(initialTab);

  const tabs = [
    {
      label: translations.labels.assessment || "Assessment",
      content: <ListAssessment />,
    },
    {
      label: translations.labels.remedialAssessment || "Remedial Assessment",
      content: <ListRemedial />,
    },
    {
      label: translations.labels.studyMaterial || "Study Material",
      content: <BookStudyMaterial />,
    },
  ];
  return (
    <div>

      <div className={styles.tabSection}>
        <CustomTab
          key={initialTab}
          defaultActiveTab={initialTab}
          tabs={tabs}
          onTabChange={(i) => setActiveTab(i)}
        />

      </div>
    </div>
  )
}

export default BookAssessment;